export default function () {
    const verticalSlider = document.querySelectorAll('.vertical-slider');
    const verticalSliderV2 = document.querySelectorAll('.vertical-slider-v2');
    const sliders = [...verticalSlider, ...verticalSliderV2]
    if (!sliders.length) return;

    sliders.forEach(s => {
        const nthSlide = parseInt(s.dataset.nthSlide, 10) || 1;

        s.style.setProperty('--progress-1', '1');
        for (let i = 2; i <= nthSlide; i++) {
            s.style.setProperty(`--progress-${i}`, '0');
        }

        window.gsap.to(s, {
            scrollTrigger: {
                trigger: s,
                start: "top top",
                end: "bottom bottom",
                markers: false,
                onUpdate: (self) => {
                    s.style.setProperty('--progress', self.progress.toFixed(3));

                    const numSections = nthSlide - 1;
                    for (let i = 2; i <= nthSlide; i++) {
                        const sectionProgress = Math.max(0, (self.progress * numSections) - (i - 2));
                        s.style.setProperty(`--progress-${i}`, Math.min(1, sectionProgress).toFixed(3));
                    }
                }
            }
        });
    })
}
